import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import profileReducer from '../features/userProfile/profileSlice';
import toastReducer from '../features/uiHelpers/toastSlice';
import qualityReducer from '../features/quality/qualitySlice';
import { apiSlice } from '../features/api/apiSlice'

export const store = configureStore({
    reducer: {
        counter: counterReducer,
        profile: profileReducer,
        toast: toastReducer,
        quality: qualityReducer,
        [apiSlice.reducerPath]: apiSlice.reducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(apiSlice.middleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
